import { Card } from '@nackle/paper';
import { RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';
import { formatCmxRomDescKey, formatCmxRomInstructionsKey, formatCmxRomNameKey } from 'routes/updatecmx/cmxKeyNames';
import { CardHeader } from 'shared/card-header';
import { TranslationEditorWrapper } from './TranslationEditorWrapper';


interface Props extends RouteComponentProps {
    romId: string;
}

export default class UpdateContentForm extends Component<Props> {
    render() {
        const { romId } = this.props;

        return (
            <Card className="content">
                <CardHeader className="content-configuration" title="Content Configuration" />

                <TranslationEditorWrapper
                    keyName={formatCmxRomNameKey(romId)}
                    label="Game Name"
                />

                <TranslationEditorWrapper
                    keyName={formatCmxRomDescKey(romId)}
                    label="Game Description"
                />

                <TranslationEditorWrapper
                    keyName={formatCmxRomInstructionsKey(romId)}
                    label="Instructions"
                />
            </Card>
        );
    }
}
